import { HttpClient } from '@angular/common/http';
import { Inject } from '@angular/core';
import { CrudService, ENVIRONMENT, HateoasMultipleResponseObject, PageSpecification, addPageSpecificationParameters, appendSerialisedHttpParams } from '@scisys-uim/uim-common';
import { ASSETS_USER_DETAILS_TYPE, AssetsUserDetails } from 'assets-model';
import { Observable } from 'rxjs';



export abstract class AssetsUserDetailsServiceBase extends CrudService<AssetsUserDetails, string> {

  servicePath: string = '/assetsuserdetails';

  constructor(protected http: HttpClient, 
      @Inject(ENVIRONMENT) protected environment: any) {
    super(http, environment, ASSETS_USER_DETAILS_TYPE.entityDecorator);
  }

  public findByFullFilters(filters: any, pageSpec?: PageSpecification, reduced: boolean = true): Observable<HateoasMultipleResponseObject<AssetsUserDetails>> {
    var params = appendSerialisedHttpParams(filters);
	
    params = appendSerialisedHttpParams(reduced, 'reduced', params);

    if (pageSpec) {
      params = addPageSpecificationParameters(pageSpec, params);
    }
	
    return this.deserialiseMultipleResponse(this.http.get<HateoasMultipleResponseObject<AssetsUserDetails>>(this.serviceBaseUrl + (pageSpec ? '/findByFullFilters' : '/findByFullFiltersUnpaged'), {
      params: params
    }));
  }
}



